import React, { memo } from 'react';
import { AdditionalBetButtons } from '../../../components';

export const GameMainBottom = memo(({ activeFreeBet }) => {
  return (
    <div className='dream-wheel-bottom'>
      <AdditionalBetButtons activeFreeBet={activeFreeBet} />
    </div>
  );
});
